export const constantsApp = {
  components: {
    calendar: {
      SELECT_WEEK: "Seleccione una semana"
    },
    community: {
      NAME: "Nombre",
      RUT: "Rut",
      VEHICLE: "Vehículo",
      PLATE: "Patente",
      STATUS: "Estado",
      TIME: "Hora"
    },
    forms: {
      accounts: {
        signIn: {
          signInSchema: {
            INVALID_EMAIL: "Correo inválido",
            REQUIRED: "Campo obligatório"
          },
          textFields: {
            EMAIL_PH: "Correo electronico",
            PASSWORD_PH: "Contraseña"
          },
          buttons: {
            SUBMIT: "Ingresar"
          }
        },
        signUp: {
          signUpSchema: {
            INVALID_EMAIL: "Correo inválido",
            REQUIRED: "Campo obligatório"
          },
          textFields: {
            EMAIL_PH: "Correo electronico",
            PASSWORD_PH: "Contraseña",
            CONFIRM_PASS: "Confirmar contraseña",
            PASS_MISS_MATCH: "Contraseñas no coinciden"
          },
          buttons: {
            SUBMIT: "Registrar"
          }
        }
      },
      community: {
        community: {
          communitySchema: {
            INVALID_EMAIL: "Correo inválido",
            REQUIRED: "Campo obligatório",
            UNSUPPORTED_FORMAT: "Formato no soportado"
          },
          textField: {
            UPLOAD_FILE: "Subir imagen",
            EMAIL_LBL: "Correo electronico",
            PASSWORD_LBL: "Contraseña",
            NAME_LBL: "Nombre",
            ADDRESS_LBL: "Dirección",
            LATITUDE_LBL: "Latitud",
            LONGITUDE_LBL: "Longitud",
            MAX_HEIGHT_LBL: "Altura maxima"
          }
        },
        partner: {
          partnerSchema: {
            INVALID_EMAIL: "Correo inválido",
            REQUIRED: "Campo obligatório",
            INVALID_ID: "Rut invalido",
            INVALID_PHONE: "Telefono inválido"
          },
          textField: {
            ID_LBL: "Rut",
            EMAIL_LBL: "Correo electronico",
            PASSWORD_LBL: "Contraseña",
            NAME_LBL: "Nombre",
            LAST_NAME_LBL: "Apellido",
            DEP_NUM_LBL: "Número de departamento",
            PHONE_LBL: "Telefono (+56 9 5555 5555)"
          }
        },
        worker: {
          workerSchema: {
            INVALID_EMAIL: "Correo inválido",
            REQUIRED: "Campo obligatório",
            INVALID_ID: "Rut invalido",
            INVALID_PHONE: "Telefono inválido"
          },
          textField: {
            ID_LBL: "Rut",
            EMAIL_LBL: "Correo electronico",
            PASSWORD_LBL: "Contraseña",
            NAME_LBL: "Nombre",
            LAST_NAME_LBL: "Apellido",
            PHONE_LBL: "Telefono (+56 9 5555 5555)"
          }
        }
      },
      partner: {
        parking: {
          parkingSchema: {
            REQUIRED: "Campo obligatório"
          },
          textField: {
            UPLOAD_IMAGE: "Subir imagen",
            UPLOAD_CERTIFICATE: "Subier certificado",
            SPOT_LBL: "Numero de estacionamiento"
          }
        }
      }
    },
    worker: {
      table: {
        NAME: "Nombre",
        ID: "Rut",
        VEHICLE: "Marca",
        PLATE: "Patente",
        STATUS: "Estado",
        TIME: "Hora"
      }
    }
  },
  pages: {
    adminPage: {
      ADD_COMMUNITY_BUTTON: "Agregar comunidad"
    },
    communityPage: {
      ADD_PARTNER_BUTTON: "Agregar Partner",
      ADD_WORKER_BUTTON: "Agregar Conserje",
      ADD_PARKING_BUTTON: "Agregar estacionamiento"
    },
    partnerPage: {
      ADD_PARKING_BUTTON: "Agregar Estacionamiento",
      ADD_SCHEDULE_BUTTON: "Agregar Horario",
      SEND_INVITATION_BUTTON: "Enviar invitación"
    },
    workerPage: {}
  },
  layouts: {
    headers: {
      admin: {
        TITLE: "Administrador",
        ADD_COMMUNITY_BUTTON: "Agregar comunidad"
      },
      community: {
        TITLE: "Comunidad",
        ADD_PARTNER_BUTTON: "Agregar Partner",
        ADD_WORKER_BUTTON: "Agregar Conserje",
        ADD_PARKING_BUTTON: "Agregar estacionamiento"
      },
      logs: {},
      partner: {
        TITLE: "Partner",
        ADD_PARKING_BUTTON: "Agregar Estacionamiento",
        ADD_SCHEDULE_BUTTON: "Agregar Horario",
        SEND_INVITATION_BUTTON: "Enviar invitación"
      }
    },
    navigation: {
      drawer: {
        HOME_LBL: "Inicio",
        COMMUNITY_LBL: "Comunidad",
        WORKER_LBL: "Conserje",
        PARTNER_LBL: "Partner",
        ADMIN_LBL: "Administrador",
        LOGOUT_LBL: "Salir"
      }
    },
    pages: {}
  },
  alert: {
    ALERT_SUCCESS: "Registro exitoso!"
  },
  routes: {
    ADMIN: "/admin",
    COMMUNITY: "/community",
    LOGS: "/logs",
    WORKER: "/worker",
    PARTNER: "/partner"
  },
  butons: {
    CANCEL: "Cancelar",
    DONE: "Aceptar",
    BOOK: "Reservar",
    CONFIRM: "Confirmar",
    GET_IN: "Entrar",
    GO_OUT: "Salir",
    GO: "Ir",
    CLOSE: "Cerrar",
    LOGIN: "Entrar",
    FORGOT_PASS: "¿Olvidó su contraseña?",
    SIGN_UP: "Registrar",
    NEXT: "Siguiente",
    PREV: "Atras",
    YES: "Si",
    NO: "No"
  }
};
